import { render, staticRenderFns } from "./QuizTeacherWorkBackground.vue?vue&type=template&id=9672aeb8&"
import script from "./QuizTeacherWorkBackground.vue?vue&type=script&lang=js&"
export * from "./QuizTeacherWorkBackground.vue?vue&type=script&lang=js&"
import style0 from "./QuizTeacherWorkBackground.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports